import { BUTTON_KIND, BUTTON_SIZE } from 'parkdepot-shared/components/Buttons'
import { useTranslation } from 'react-i18next'
import { ActionsContainer } from './CarpayOrderActions.style'
import React from 'react'
import Button from 'parkdepot-shared/components/Buttons/Button'

const PayNowOrLaterActions = ({ onPayNow, onPayLater }: { onPayNow: () => void; onPayLater: () => void }) => {
    const { t } = useTranslation()

    return (
        <ActionsContainer>
            <Button id="pay-now-button" $kind={BUTTON_KIND.primary} onClick={onPayNow} $size={BUTTON_SIZE.medium}>
                {t('carpay.orderActions.payNow')}
            </Button>

            <Button id="pay-later-button" $kind={BUTTON_KIND.primary} onClick={onPayLater} $size={BUTTON_SIZE.medium}>
                {t('carpay.orderActions.payLater')}
            </Button>
        </ActionsContainer>
    )
}

export default PayNowOrLaterActions
